exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LastExpenses_emptyMessage_21Ey {\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"emptyMessage": "LastExpenses_emptyMessage_21Ey"
};